export default __webpack_public_path__ + "static/media/main_inquiry.cf54d1c7.svg";